<template>
    <div class="grade-query">
        <site-header />
        <div class="content-container">
            <div class="page-title">成绩查询</div>
            <div class="result-table" v-if="tableData.length > 0">
                <el-table :data="tableData" style="width: 100%" border :header-cell-style="{
                    background: '#f5f7fa',
                    color: '#606266',
                    fontWeight: 'bold',
                    textAlign: 'center'
                }" :cell-style="{
                    textAlign: 'center'
                }">
                    <el-table-column prop="examName" label="考试名称" min-width="200"></el-table-column>
                    <!-- <el-table-column prop="examType" label="考试类型" min-width="120">
                        <template slot-scope="scope">
                            <el-tag size="medium" effect="plain">{{ getExamTypeName(scope.row.examType) }}</el-tag>
                        </template>
</el-table-column> -->
                    <el-table-column prop="totalScore" label="得分" min-width="100">
                        <template slot-scope="scope">
                            <span class="score-text">{{ scope.row.totalScore }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="考试时间" min-width="180"></el-table-column>
                    <el-table-column prop="status" label="状态" min-width="100">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.totalScore >= 60 ? 'success' : 'danger'" effect="dark"
                                size="medium">
                                {{ scope.row.totalScore >= 60 ? '通过' : '未通过' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="no-data" v-else>
                <el-empty description="暂无数据"></el-empty>
            </div>
        </div>
        <site-footer />
    </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { ExamRecordList } from '@/api/apis'
import { bizTypeEnum } from '@/utils/enum'

export default {
    name: 'GradeQuery',
    components: {
        SiteHeader,
        SiteFooter
    },
    data() {
        return {
            tableData: []
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            try {
                const res = await ExamRecordList({
                    majorIds: [44, 46]
                })
                if (res.code === 200) {
                    this.tableData = res.rows
                } else {
                    this.$message.error(res.msg || '获取数据失败')
                }
            } catch (error) {
                console.error('获取数据失败:', error)
                this.$message.error('获取数据失败，请稍后重试')
            }
        },
        getExamTypeName(type) {
            return bizTypeEnum[type] || '未知类型'
        }
    }
}
</script>

<style scoped>
.grade-query {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #f5f7fa;
}

.content-container {
    flex: 1;
    padding: 40px 20px;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
}

.page-title {
    font-size: 24px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 24px;
    padding-left: 8px;
    border-left: 4px solid #409EFF;
}

.result-table {
    background: #fff;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.score-text {
    font-size: 16px;
    font-weight: bold;
    color: #409EFF;
}

.no-data {
    background: #fff;
    padding: 60px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    text-align: center;
}

:deep(.el-table) {
    border-radius: 8px;
    overflow: hidden;
}

:deep(.el-table th) {
    padding: 12px 0;
}

:deep(.el-table td) {
    padding: 16px 0;
}

:deep(.el-tag) {
    border-radius: 4px;
    padding: 0 12px;
    height: 28px;
    line-height: 26px;
}
</style>